import util from '../util'

let controller = 'StatusServico'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), { 
  StatusServicos: function (dto) {
    return util.Axios.GetAll(controller + '/StatusServicos', dto)
  },  
})
